import { Component, OnInit, Input, ViewChild } from '@angular/core';
import * as shape from 'd3-shape';
import { morseCode, nodes, edges, morseDecode } from '../../../assets/morse';
import { TopicService } from '../topic.service';
import { CryptoService } from '../crypto.service';
import { CryptoView } from '../crypto-view';
import { GraphComponent } from '../../shared/graph/graph.component';

@Component({
  selector: 'app-morse',
  templateUrl: './morse.component.html',
  styleUrls: ['../topic-style.css', './morse.component.css']
})
export class MorseComponent extends CryptoView {

  @ViewChild(GraphComponent, {static: true}) graph: GraphComponent;

  private _current: string;
  @Input()
  set current(value: string) {
    console.log(value)
    this._current = value;

  }
  get current() {
    if (this.modus == "highlight" && this._current) {
      return this._current
    } else {
      return " ";
    }
  }
  _modus: string;
  @Input()
  set modus(value: string) {
    this._modus = value;
    this.current = this.current;
  }
  get modus() {
    return this._modus;
  }

  @Input() direction: string;

  @Input() errors: number[] = [];

  inputs: string[];
  hints: string[] = [];


  view: any[] = [600, 300];
  fitContainer: boolean = true;
  curve = shape.curveLinear;
  nodes = nodes;
  edges = edges;
  morseCode = morseCode;
  morseDecode = morseDecode;

  constructor(public topicService: TopicService, protected cryptoService: CryptoService) {
    super(topicService);
    this.inputs = new Array(26).fill(" ");
    for(let i in morseDecode){
      console.log(i);
    }
    console.log(Object.keys(morseDecode));
  }

  /** used by the html to highlight the correct element */
  currentIndex(): number {
    if (this.modus == "highlight") {
      return this.current.charCodeAt(0) - 65;
    } else if (this.modus == "withoutKey") {
      return this.current.charCodeAt(0) - 65;
    } else {
      return -1;
    }
  }


  /** returns the student mapping */
  getMapping() {
    return this.inputs.slice(0, 26).join(",");
  }

  /** sets the mapping */
  setmapping(mapping: string) {
    let mappingArray = mapping.split(",");
    for(let i = 0; i < 26; i++){
      if(!this.hints[i]){
        this.inputs[i] = mappingArray[i];
      }
    }
    //this.inputs = mapping.split(",").slice(0, 26);
  }

  /** resets the mapping */
  resetmapping() {
    this.setmapping(",,,,,,,,,,,,,,,,,,,,,,,,,,,")
  }

  /** set the hints */
  setHints(hints: string[]) {
    this.hints = hints;
    for(let i = 0; i < 26; i++){
      if(!this.hints[i]){
        this.inputs[i] = "";
      } else {
        this.inputs[i] = hints[i]
      }
    }
    console.log(this.inputs);
  }

  /** fill the mapping with correct letters */
  fillMapping() {
    for (let i in this.createArray(26)) {
      this.inputs[i] = String.fromCharCode(+i + 65);
    }
  }

  /** hichlights all edges on the way to the current Letter */
  onPath(source: string, current: string) {
    return this.morseCode[this.current.toLowerCase()].startsWith(this.morseCode[source.toLowerCase()]);
  }

  /** returns the letter matching the given morse code */
  getLetterBasedOnInput(position: string){
    if(position == "start"){
      return "start";
    }
    let correctCode = this.morseCode[position.toLowerCase()];
    let index = this.inputs.indexOf(correctCode);
    if(index >= 0){
      return String.fromCharCode(index + 65);
    } else {
      return "";
    }
  }

  /** returns all morse codes */
  getKeys(obj: any): string[]{
    return Object.keys(obj).filter(v => v!=' ');
  }

}
